module.exports = __webpack_public_path__ + "static/media/insta.6f7b0ead.svg";